import React from 'react';
import { Link } from 'react-router-dom';
import ShopLayout from './ShopLayout.js';
import LegalHero from './LegalHero.js';

const EMERALD = '#059669';
const FLARE_RED = '#c4151c';

export default function ShopRefundPolicySection() {
  return (
    <ShopLayout pageTitle="Refund Policy" currentPage="refund">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <LegalHero
          kicker="digital.flare.pk"
          title="Refund Policy"
          updated={<>Last updated: <span className="text-gray-700">October 21, 2026</span></>}
          image="/legal/refund.png"
          accent={EMERALD}
        />

        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 sm:p-10 space-y-7 text-gray-600 leading-relaxed">
          <p>
            This policy applies to paid purchases on <strong className="text-gray-900">digital.flare.pk</strong>, operated by Flare Magazine.
            We sell <strong className="text-gray-900">printed magazine issues</strong> and <strong className="text-gray-900">print subscriptions</strong> only.
            Digital PDF editions, where available, are provided <strong className="text-gray-900">free of charge</strong> and are not a paid product.
          </p>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2.5">Eligible refunds</h2>
            <p className="mb-3">
              A refund or replacement is issued only when fulfilment cannot be completed for reasons on our side:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong className="text-gray-900">Stock unavailable</strong> — if the ordered issue or subscription cannot be fulfilled due to insufficient stock or unavailability, we cancel the order and refund the amount paid.
              </li>
              <li>
                <strong className="text-gray-900">Fulfilment error</strong> — if an incorrect issue is delivered, the copy arrives damaged, or the courier confirms the parcel is lost, we will either replace the item at no cost or refund the relevant order amount.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2.5">Non-refundable cases</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong className="text-gray-900">Customer-initiated cancellation</strong> — orders cannot be cancelled by the customer after placement. Once submitted, an order proceeds to packing and dispatch, and is not eligible for a voluntary refund.
              </li>
              <li>
                Change of mind, dissatisfaction with editorial content, or an incorrect delivery address entered by the customer at checkout.
              </li>
              <li>
                Free digital PDFs — no payment is collected, therefore no refund applies.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2.5">Processing timelines after approval</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong className="text-gray-900">Replacement dispatch:</strong> 24–48 hours (tracking shared by SMS / email).</li>
              <li><strong className="text-gray-900">JazzCash / EasyPaisa:</strong> 24–72 hours (often same day if approved before 3 PM PKT).</li>
              <li><strong className="text-gray-900">Bank / IBFT:</strong> 3–5 working days (Mon–Fri bank settlement).</li>
              <li><strong className="text-gray-900">Debit / Credit Card:</strong> 5–10 working days, depending on your issuing bank.</li>
            </ul>
            <p className="mt-3 text-sm text-gray-500">
              If a refund does not appear within these windows, email{' '}
              <a href="mailto:digital@flare.pk" className="font-semibold hover:underline" style={{ color: FLARE_RED }}>digital@flare.pk</a>
              {' '}with your order number and a bank statement screenshot so we can raise a trace.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-2.5">How to contact us</h2>
            <p>
              For stock or delivery issues, please write to us with your order number (e.g. FLR-…) through our{' '}
              <Link to="/contact" className="font-semibold hover:underline" style={{ color: FLARE_RED }}>Contact</Link>
              {' '}page or at{' '}
              <a href="mailto:digital@flare.pk" className="font-semibold hover:underline" style={{ color: FLARE_RED }}>digital@flare.pk</a>.
            </p>
          </section>
        </div>
      </div>
    </ShopLayout>
  );
}
